import { render, staticRenderFns } from "./FrameworkAgreementSeller.vue?vue&type=template&id=954b54ba&scoped=true&"
import script from "./FrameworkAgreementSeller.vue?vue&type=script&lang=js&"
export * from "./FrameworkAgreementSeller.vue?vue&type=script&lang=js&"
import style0 from "./FrameworkAgreementSeller.vue?vue&type=style&index=0&id=954b54ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954b54ba",
  null
  
)

export default component.exports